module.exports = __webpack_public_path__ + "img/account-review-passed-icon.2463ded1.png";